<template>
    <div class="tw-wait-list">
        <div class="tw-info-box-container">
            <div class="tw-info-box-overlay" v-on:click="closeWaitList()"></div>
            <div class="tw-info-box" v-on:click.stop>
                <loading-splash v-if="loading"></loading-splash>
                <transition name="fade">
                    <div id="wait-list-widget" class="tw-wait-list-widget"></div>
                </transition>
                <div class="tw-text--center">
                    <button type="button" class="tw-btn__link" v-on:click="closeWaitList()">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
    import { Vue } from "vue-property-decorator";
    import { Component, Prop } from "vue-property-decorator";
    import TicketWidgetComponent from '../../TicketWidgetComponent';
    import CalendarItem from "../../../models/CalendarItem";
    import LoadingSplash from '../loading-splash/LoadingSplash.vue';

    /** Location for the wait list widget */
    declare var WAIT_LIST_HOST: string;

    @Component({
        components: {
            LoadingSplash
        }
    })

    export default class WaitListWidget extends TicketWidgetComponent {
        @Prop() public calendarItem!: CalendarItem;

        public loading: boolean = true; 

        /**
        * @desc when mounted, grab the current stage and see if its previous stage exists
        */
        mounted() {
            this.prepareWaitListWidget(this.calendarItem);
        }

        /**
         * @desc sets up the initial load of the calendar view
         */
        closeWaitList() {
            this.$root.$emit('closeWaitList');
        }

        /**
         * @desc sets up the initial load of the calendar view
         */
        prepareWaitListWidget(calendarItem: any) {
            let element: any = document.getElementById('dmn-partner-widget');
            
            if(element) {
                element.parentNode.removeChild(element);
            }

            if(calendarItem.offSale === 'Sold Out' && this.selectedEvent.show_waiting_list) {
                let itemDate = calendarItem.dateMoment.format('YYYY-MM-DD');

                let waitListWidgetScript = document.createElement('script');
                waitListWidgetScript.setAttribute('src', WAIT_LIST_HOST + '?item-id=' + this.selectedEvent._id + '&source=' + this.dmnOptions.source + '&show-photo=true&item-date=' + itemDate);

                let widgetParent:any = document.getElementById('wait-list-widget');
                widgetParent.appendChild(waitListWidgetScript);

                setTimeout(() => {
                    this.loading = false;
                }, 750);
            }
        }
    }
</script>